var diagnostics = function()
{
	var instance = {};
	
	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].data = component.init_config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		var tooltip_label_average = '% -Average Satisfaction';
		var tooltip_label_best = '% - Best performing';
		var tooltip_label_compare = '% - Comparison value';

		var categories = typeof resultComponentVal.config != 'undefined' && 
							typeof resultComponentVal.config.category != 'undefined'?resultComponentVal.config.category:{};

		var tooltip_labels = typeof resultComponentVal.config != 'undefined' && 
							typeof resultComponentVal.config.tooltip_labels != 'undefined'?resultComponentVal.config.tooltip_labels:{};

		if(typeof tooltip_labels.average != 'undefined')
		{
			tooltip_label_average = tooltip_labels.average;
		}
		if(typeof tooltip_labels.best != 'undefined')
		{
			tooltip_label_best = tooltip_labels.best;
		}
		if(typeof tooltip_labels.compare != 'undefined')
		{
			tooltip_label_compare = tooltip_labels.compare;
		}
		
		var itemCount = 0;
		var i;
		for (i in categories) {
		    if (categories.hasOwnProperty(i)) {
		        itemCount++;
		    }
		}
		//COMPUTE CHART HEIGHT FROM THE NUMBER OF ITEMS
		var chart_height = itemCount*69 +40;
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		var config_data = resultComponentVal.config;

		config_data.options.chart.height = chart_height;

		//Disable legend item click action for all charts by default
		config_data.options.plotOptions.series.events = {
                legendItemClick: function () {return false;}
        };
        
        config_data.options.plotOptions.series.dataLabels = {
          "useHTML":true,
          "enabled":true,
          "style":{
            "font": "Arial",
            "fontSize": "11px"
          },
          "formatter": function() {
          	var color = this.point.color;
          	var val = this.point.y;
          	var best_value = this.point.best_value;
			
            val = typeof val == 'number' ? parseFloat(Math.round(val * 100) / 100).toFixed(1) : val;
          	best_value = typeof best_value == 'number' ? parseFloat(Math.round(best_value * 100) / 100).toFixed(1) : best_value;
			
          	var best_value_html = best_value.length !== 0 ?'<span style="color:#666666;"> ('+best_value+')</span>':'';
          	return '<span style="color:'+color+'">'+val+'</span>'+best_value_html;
          }
        };

        var chart_events = {
			redraw: function () {
				//reinitialize the tooltips
				$('.info-tooltip').tooltip({
			        placement : 'top'
			    });
			}
		};
		config_data.options.chart.events = chart_events;


		//Add tooltip
		config_data.options.tooltip.formatter = function(){
			var tooltip_html = "<div class=\"custom-tooltip\">";
			if(typeof this.points != 'undefined')
			{
				var points = this.points;
				var point1 = typeof points[0] != 'undefined'?points[0]:{};
				var point2 = typeof points[1] != 'undefined'?points[1]:{};
				
				var color1 = typeof point1.point.color != 'undefined'? point1.point.color :'#000';
				var color2 = typeof point2.point.color != 'undefined'? point2.point.color :'#000';
				
				var value1 = typeof point1.point.y != 'undefined'? point1.point.y :0;
				value1 = parseFloat(Math.round(value1 * 100) / 100).toFixed(1);
				
				var best_value1 = typeof point1.point.best_value != 'undefined'? point1.point.best_value.toFixed(1) :0;
				best_value1 = parseFloat(Math.round(best_value1 * 100) / 100).toFixed(1);
				
				var value2 = typeof point2.point.y != 'undefined'? point2.point.y :0;
				value2 = parseFloat(Math.round(value2 * 100) / 100).toFixed(1);
				
				tooltip_html += "<div style=\"color:"+color1+"\">"+value1+tooltip_label_average+"</div>";
				tooltip_html += "<div style=\"color:'#666666';\">"+best_value1+tooltip_label_best+"</div>";
				tooltip_html += "<div style=\"color:"+color2+"\">"+value2+tooltip_label_compare+"</div>";
			}
			else{
				var color = typeof this.point.color != 'undefined'? this.point.color: "#000";
				var value = typeof this.point.y != 'undefined'? this.point.y: 0;
				return "<div class=\"custom-tooltip\" style=\"color:"+color+"\">"+value+"% - Satisfaction</div>";
			}
			tooltip_html += "</div>"

			return tooltip_html;
		}
		config_data.options.tooltip.positioner= function (labelWidth, labelHeight, point) {
				// var height = this.chart.chartHeight-point.plotY+labelHeight+20 > this.chart.chartHeight? (point.plotY+20) : (point.plotY-labelHeight-20);
				
				var height = point.plotY+10;
				// var width = (this.chart.chartWidth / 2) + (labelWidth / 2);
				var width = this.chart.plotLeft+20;
				return {
					x: width,
					y: height
				};
			}


		scope[componentKey].data = config_data;

		setTimeout(function () {
			var chart = angular.element(
				document.getElementById(componentKey)
			).highcharts();
			chart.reflow();
      scope.$broadcast('highchartsng.reflow');
      $('.info-tooltip').tooltip({
		    placement : 'top'
		  });
   	}, 500);
		
		scope.$broadcast('highchartsng.reflow');
	};

	return instance;
};
